import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../AuthContext";
import Header from "./Header";
import PageHeader from "./PageHeader";
export default function AppLayout() {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="app-shell">
      <Header />
      <main className="midial-part app-main">
        <PageHeader />
        <div className="app-page-content">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
